import React, {
  createContext, useContext, useMemo, useEffect
} from 'react';
import { node, any, string, func } from 'prop-types';
import { useProduct } from '@thd-nucleus/data-sources';
import { transformItemDataToPromoModel } from '../utils/promo-model-utils';

export const PromoModelContext = createContext();
export const usePromoModel = () => useContext(PromoModelContext);

export const PromoModelProvider = ({
  anchorItem, storeId, storeZip, setIsBatchLoading, children
}) => {

  const { data, loading } = useProduct({
    itemIds: anchorItem.pricing.promotion.itemList,
    storeId,
    domains: ['$ProductPod'],
  });

  useEffect(() => setIsBatchLoading(loading), [loading, setIsBatchLoading]);
  const promoModel = useMemo(() => transformItemDataToPromoModel(data?.products, anchorItem), [data, anchorItem]);

  const contextValue = {
    storeId,
    storeZip,
    anchorItem,
    anchorItemId: anchorItem.itemId,
    anchorItemImage: promoModel.anchorItemImage,
    products: promoModel.products,
    promoId: promoModel.promoId,
    isBogo: promoModel.isBogo,
    isMsb: promoModel.isMsb,
    allItemIds: promoModel.allItemIds,
    hasProducts: promoModel.hasProducts,
    itemCount: promoModel.itemCount,
    singleItemIdToDisplay: promoModel.singleItemIdToDisplay,
    experienceTag: promoModel.experienceTag,
    subExperience: promoModel.subExperience,
    bogoMaxQuantity: 1, // TODO: link to dynamic data when available
    minPurchaseAmount: promoModel.minPurchaseAmount,
    minPurchaseQuantity: promoModel.minPurchaseQuantity,
    rewardAmountPerItem: promoModel.rewardAmountPerItem,
    rewardAmountPerOrder: promoModel.rewardAmountPerOrder,
    rewardPercent: promoModel.rewardPercent,
  };

  return (
    <PromoModelContext.Provider value={contextValue}>
      { children }
    </PromoModelContext.Provider>
  );
};

PromoModelProvider.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  anchorItem: any,
  storeId: string.isRequired,
  storeZip: string,
  setIsBatchLoading: func.isRequired,
  children: node.isRequired,
};

PromoModelProvider.defaultProps = {
  anchorItem: {},
  storeZip: '',
};
